import { ConciergeContextSettingsParser } from "@redotech/redo-concierge-settings-common/context-settings-db-parser";
import * as z from "zod";

export const getConciergeContextSettings = {
  name: "getConciergeContextSettings" as const,
  input: z.null(),
  output: z.object({
    conciergeContextSettings: ConciergeContextSettingsParser.optional(),
  }),
};
